module.exports = __webpack_public_path__ + "img/50000元年.2b45fec6.png";